import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { MareAuthService } from '@mare-common/ngx-mare-auth';
import { environment } from 'src/environments/environment';
import { UserCompanyService } from '../services/userCompany.service';
import { PromoModalData, PromoModalComponent } from '../shared/promo-modal/promo-modal.component';
import { PlatformApiWPublicService } from '../services/platform-apiwp-public.service';
import { catchError, Observable, take } from 'rxjs';
import { TokenService } from '../services/token.service';
import { RoutingService } from '../services/routing.service';

@Component({
  selector: 'app-registration-request',
  templateUrl: './registration-request.component.html',
  styleUrls: ['./registration-request.component.scss']
})
export class RegistrationRequestComponent implements OnInit {
  user: any;
  buttonDisabled: boolean = false;
  numSeconds: number = 60;
  redirect_uri: string | null = null;
  delfi_token: any;
  expireTime: number | null = null;

  constructor(
    private platformApi: PlatformApiWPublicService,
    private router: Router,
    private route: ActivatedRoute,
    private tokenService: TokenService,
    private authService: MareAuthService,
    private routingService: RoutingService
  ) {

  }
  ngOnInit(): void {
    console.log('test');
    this.checkButton();
    this.redirect_uri = this.route.snapshot.queryParams['redirect_uri'];
    this.delfi_token = this.route.snapshot.queryParams['delfi_token'];
    if(this.tokenService.isInit$) {
      this.tokenService.isInit$.subscribe((res: boolean) => {
        if(res) {
          if(this.authService.isLogged()) {
            if(this.redirect_uri) {
              if(this.redirect_uri.trim().indexOf('http') == -1) {
                this.router.navigate([this.redirect_uri]);
              } else {
                window.location.href = this.redirect_uri;
              }
            }
          } else {
            this.routingService.registerRedirect(this.redirect_uri);
          }
        }
      })
    }

  }




  submitForm() {
    // console.log(this.completeProfileForm.value);
    this.buttonDisabled = true;
    this.platformApi.getRequest('msc/v1/registrationMail').then((obs: Observable<any>) => {
      obs
        .pipe(
          take(1),
          catchError((err: any) => {
            console.log(err);
            this.buttonDisabled = false;
            return err
          })
        )
        .subscribe((res: any) => {
          console.log(res);
          // TODO alert invio avvenuto
          // alert('Richiesta di registrazione inviata correttamente');
          this.setExpireNextSend();
          this.checkButton();
        })
    }).catch((err: any) => {
      this.buttonDisabled = false;
      console.log(err);
    })
  }

  setExpireNextSend() {
    localStorage.setItem('expireNextSend', (new Date().getTime() + this.numSeconds * 1000).toString());
  }

  checkCanEnableButton(expire: string | null = null) {
    if(!expire)
      expire = localStorage.getItem('expireNextSend');
    return (new Date().getTime() > Number(expire || 0));
  }

  getExpire() {
    return localStorage.getItem('expireNextSend');
  }

  checkButton() {
    const expire = this.getExpire();
    if (this.checkCanEnableButton(expire)) {
      this.buttonDisabled = false;
      this.expireTime = null;
    } else {
      this.expireTime = Math.round((Number(expire) - new Date().getTime())/1000);
      this.buttonDisabled = true;
      setTimeout(() => {
        this.checkButton();
      }, 500);
    }
  }

  goToLogin() {
    let params: any = {};
    if (this.redirect_uri) {
      params.redirect_uri = this.redirect_uri
    }
    if (this.delfi_token) {
      params = {
        'delfi_token': this.delfi_token
      }
    }
    this.router.navigate([environment.routingBasePath + '/login'], { queryParams: params });
  }


  resetPassword() {
    window.location.href = window.location.href = environment.oauthConfig.oauthIssuer + '/login-actions/reset-credentials?client_id=web';
  }


  
}
